// src/utils/axios.js
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',  // same-origin by default
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response interceptors
instance.interceptors.response.use(
  response => response,
  error => {
    // Handle timeout specifically
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      console.error('Request timeout:', error.config?.url);
      return Promise.reject(new Error('Request timeout. Please try again.'));
    }
    
    // Handle 401 errors more intelligently
    if (error.response?.status === 401) {
      const url = error.response?.config.url;
      
      // Allow MFA-related 401s to be handled by the components
      if (url === '/auth/login/mfa' || url === '/auth/login/backup-code') {
        return Promise.reject(error);
      }
      
      // Handle regular login 401
      if (url === '/auth/login') {
        return Promise.reject(new Error('Invalid email or password'));
      }
      
      // For other 401s, redirect to login (user session expired)
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    // Log other errors for debugging
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);


export default instance;